module.exports = __webpack_public_path__ + "img/conduct.15eca9ef.png";